<script setup lang="ts">
const emit = defineEmits<{
  (e: 'toggle'): void
}>()

const props = withDefaults(defineProps<{
    active?: boolean
    fixed?: boolean
  }>(), { active: false, fixed: false })
</script>

<template>
  <span
    class="hamburger menu-trigger"
    :class="{ active, fixed }"
    @click="emit('toggle')"
  >
    <div class="circle icon" :class="{ close: active }">
      <span class="line top" />
      <span class="line middle" />
      <span class="line bottom" />
    </div>
  </span>
</template>

<style lang="scss" scoped>
.hamburger {
    display: inline-block;
    position: relative;
    cursor: pointer;
    width: 54px;
    height: 54px;

    display: flex;
    align-items: center;

    .circle {
        width: 28px;
        height: 29px;
        position: relative;
    }

    .line {
        position: absolute;
        height: 2px;
        width: 100%;
        background: white;
        border-radius: 8px;
        transition: all cubic-bezier(0.26, 0.1, 0.27, 1.55) 0.35s,
            background-color 0.75s ease-in-out;
        background: white;

    }

    &.active {
        .line {
            background: white !important;
        }
    }

    &.fixed {
        .line {
            background: var(--i-blue) !important;
        }

        &.active {
            .line {
                background: var(--i-blue) !important;
            }
        }
    }

    .top {
        top: 18%;
    }

    .middle {
        top: 48%;
    }

    .bottom {
        top: 78%;
    }

    .icon.close .top {
        transform: rotate(45deg);
        top: 48%;
    }

    .icon.close .middle,
    .icon.close .bottom {
        transform: rotate(-45deg);
        top: 48%;
    }

}
</style>
